import axiosClient from "./axiosClient";

async function getDocuments(
  bookingNumber: string,
  customerId: string,
  orderId: string,
  orgunit: string
) {
  const bodyRequest = { bookingNumber, customerId, orderId, orgunit };

  try {
    const response = await axiosClient.post(
      "/documents/getUserDocs",
      bodyRequest
    );

    if (response.status !== 200) {
      console.warn(`api call response is not 200 ok!`);
      return null;
    }
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export default getDocuments;
